import { useState } from 'react';
import DownloadModal from '../../../components/DownloadModal';

export default function Benefits() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const benefits = [
    { icon: '🩺', title: 'Clínica Geral',            description: 'Avaliação e encaminhamento especializado',              clinic: 'COTI' },
    { icon: '🧠', title: 'Neurologia',               description: 'Doenças do sistema nervoso',                            clinic: 'COTI' },
    { icon: '❤️', title: 'Cardiologia',              description: 'Prevenção, diagnóstico e tratamento cardiovascular',     clinic: 'COTI' },
    { icon: '🦴', title: 'Ortopedia & Traumatologia',description: 'Aparelho locomotor, lesões, dor crônica e reabilitação', clinic: 'COTI' },
    { icon: '🧩', title: 'Psiquiatria',              description: 'Saúde mental e emocional',                              clinic: 'COTI' },
    { icon: '💧', title: 'Urologia',                 description: 'Saúde urológica do adulto e idoso',                     clinic: 'COTI' },
    { icon: '🦠', title: 'Reumatologia',             description: 'Doenças autoimunes e inflamatórias',                    clinic: 'COTI' },
    { icon: '🧪', title: 'Endocrinologia',           description: 'Distúrbios hormonais e metabólicos',                    clinic: 'COTI' },
    { icon: '🫁', title: 'Cirurgia Torácica',        description: 'Avaliação e procedimentos respiratórios',               clinic: 'COTI' },
    { icon: '🥗', title: 'Nutrição',                 description: 'Acompanhamento nutricional personalizado',               clinic: 'COTI' },
    { icon: '🧒', title: 'Pediatria',                description: 'Cuidado integral das crianças',                         clinic: 'COTI' },
    { icon: '🌬️', title: 'Pneumologia',             description: 'Doenças respiratórias e do sono',                       clinic: 'COTI' },
    { icon: '🧘', title: 'Psicologia',               description: 'Apoio emocional e desenvolvimento pessoal',             clinic: 'COTI' },
    { icon: '💪', title: 'Fisioterapia',             description: 'Reabilitação e tratamento físico especializado',         clinic: 'Fisiocor' },
  ];

  return (
    <>
      <section id="beneficios" className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-[#0A1628] mb-4">Parceiros em Destaque</h2>
            <p className="text-lg text-gray-600">Condições especiais nas clínicas COTI e Fisiocor</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 hover:shadow-xl transition-all duration-300 border border-gray-100 group hover:-translate-y-1"
              >
                {/* Icon */}
                <div className="text-5xl mb-4">{benefit.icon}</div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-800 mb-2">{benefit.title}</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{benefit.description}</p>

                {/* Clinic Badge */}
                <div className="inline-block px-3 py-1 bg-gradient-to-r from-[#00A8E8]/10 to-[#E91E63]/10 rounded-full mb-3">
                  <span className="text-xs font-semibold bg-gradient-to-r from-[#00A8E8] to-[#E91E63] bg-clip-text text-transparent">
                    {benefit.clinic}
                  </span>
                </div>

                <div className="pt-4 border-t border-gray-100">
                  <span className="inline-flex items-center gap-1.5 text-xs font-semibold bg-gradient-to-r from-[#00A8E8] to-[#E91E63] bg-clip-text text-transparent">
                    <i className="ri-sparkling-line text-[#00A8E8]"></i>
                    Condições especiais
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center mt-12">
            <button
              onClick={() => setIsModalOpen(true)}
              className="px-8 py-4 bg-gradient-to-r from-[#00A8E8] to-[#E91E63] text-white font-semibold rounded-full hover:shadow-2xl hover:shadow-[#00A8E8]/50 transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer group"
            >
              Baixar o App e Começar
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>

          {/* Info Note */}
          <div className="text-center mt-6">
            <p className="text-sm text-gray-600 font-medium">
              ✨ A assinatura é feita exclusivamente pelo aplicativo
            </p>
          </div>
        </div>
      </section>

      <DownloadModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}